"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatColumnSettingsViewItems = void 0;
const getFormatColumnSettingsViewItems = (formatColumn) => {
    var _a;
    const values = [
        `Cell alignment: ${(_a = formatColumn.CellAlignment) !== null && _a !== void 0 ? _a : 'default'}`,
        `Include grouped rows: ${formatColumn.IncludeGroupedRows ? 'Yes' : 'No'}`,
    ].filter(Boolean);
    return {
        name: 'Settings',
        values,
    };
};
exports.getFormatColumnSettingsViewItems = getFormatColumnSettingsViewItems;
